import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { replaceTokensInString } from '@app/utils';
import { CURRENCY_TYPE } from './constants';
import styles from './ProductRemanParts.module.scss';

export const getTableSchema = () => {
  const currency = useSelector(s => s.dealerCustomer.currency ?? CURRENCY_TYPE);
  const [t] = useTranslation();
  return [
    {
      id: 'mobileCell',
      width: '90%',
      className: `d-md-none ${styles['reman-parts__border-top']}`
    },
    {
      id: 'name',
      label: `${t('ITEMNAME_PARTNUMBER')}`,
      width: '65%',
      padding: '4px 0px 4px 6px',
      className: `d-none d-md-table-cell ${styles['reman-parts__border-top']}`
    },
    {
      id: 'priceAvailability',
      label: `${replaceTokensInString(t('PRICE_CODE_AVAILABILITY'), currency)}`,
      width: '30%',
      padding: '4px',
      className: `d-none d-md-table-cell ${styles['reman-parts__border-top']}`
    },
    {
      id: 'addToCart',
      label: '',
      width: '5%',
      padding: '4px 0',
      className: `px-lg-1 px-md-1 ${styles['reman-parts__border-top']}`
    }
  ];
};
